import type { Strain, StrainInput, StrainQuery, StrainSummary } from '@shared';
import { api } from './api';

/** Typed client calls for the strain catalogue. */

export interface CatalogueMeta {
  total: number;
  producers: string[];
  categories: string[];
}

function buildQuery(query: Partial<StrainQuery>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined && value !== '' && value !== 'all') {
      params.set(key, String(value));
    }
  }
  const s = params.toString();
  return s ? `?${s}` : '';
}

export const strainsApi = {
  list: (query: Partial<StrainQuery> = {}): Promise<StrainSummary[]> =>
    api.get<StrainSummary[]>(`/strains${buildQuery(query)}`),
  meta: (): Promise<CatalogueMeta> => api.get<CatalogueMeta>('/strains/meta'),
  get: (id: string): Promise<Strain> => api.get<Strain>(`/strains/${id}`),
  fieldSources: (id: string): Promise<Array<Record<string, unknown>>> =>
    api.get(`/strains/${id}/field-sources`),
  create: (input: StrainInput): Promise<Strain> =>
    api.post<Strain>('/strains', input),
  update: (id: string, input: StrainInput): Promise<Strain> =>
    api.put<Strain>(`/strains/${id}`, input),
  archive: (id: string, archived: boolean): Promise<Strain> =>
    api.post<Strain>(`/strains/${id}/archive`, { archived }),
  setVerified: (id: string, verified: boolean): Promise<Strain> =>
    api.post<Strain>(`/strains/${id}/verify`, { verified }),
  duplicate: (id: string): Promise<Strain> =>
    api.post<Strain>(`/strains/${id}/duplicate`),
  remove: (id: string): Promise<{ deleted: boolean }> =>
    api.del<{ deleted: boolean }>(`/strains/${id}`),
};
